import { UserSearchableSelect } from "@spz/ui/components/user-searchable-select";
import { CompanyDefaultOwnerSelectViewModel } from "../../view-models/company-default-owner-select-view-model";

interface CompanyDefaultOwnerSelectProps {
  companyId: string;
  defaultOwnerId?: string | null;
}

export const CompanyDefaultOwnerSelect = ({
  companyId,
  defaultOwnerId,
}: CompanyDefaultOwnerSelectProps) => {
  const {
    localOwnerId,
    usersPerCompany,
    usersListPending,
    handleSelect,
    UNASSIGNED_USER,
  } = CompanyDefaultOwnerSelectViewModel({
    companyId,
    defaultOwnerId,
  });
  return (
    <UserSearchableSelect
      users={[UNASSIGNED_USER, ...(usersPerCompany?.data ?? [])]}
      value={[localOwnerId ?? UNASSIGNED_USER.id ?? ""]}
      isLoading={usersListPending}
      onSelect={(ids) => {
        handleSelect(ids);
      }}
      className="w-[200px]"
      size="small"
    />
  );
};
